$(document).ready(function () {
    function refreshFragments() {
        $.ajax({
            url: wc_cart_fragments_params.ajax_url,
            type: 'POST',
            data: { action: 'woocommerce_get_refreshed_fragments' },
            success: function (data) {
                if (data && data.fragments) {
                    $.each(data.fragments, function (key, value) {
                        $(key).replaceWith(value);
                    });
                }
            },
            error: function (xhr, status, error) {
                console.error('Fragment refresh failed:', status, error);
            }
        });
    }

    $(document.body).on('updated_cart_totals wc_cart_emptied', refreshFragments);

});